import type {
  ApiAuthConfigs,
  ApiError,
  ApiPayloadAppInfo,
  ApiServices,
} from "./api.type";

import { useQuery } from "@tanstack/react-query";

import { client } from "@/config/client";
import { QUERY_PERSIST_KEY } from "@/services/query";

const useGetApiAppInfo = <Data = unknown>(
  endpoint: keyof typeof client.appInfo,
  persist = false
) => {
  const queryKey = ["app-info", endpoint];
  if (persist) {
    queryKey.push(QUERY_PERSIST_KEY);
  }

  const { data, ...queryResult } = useQuery<ApiPayloadAppInfo<Data>, ApiError>({
    queryKey: queryKey,
    queryFn: () => client.appInfo[endpoint](),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  return {
    data: data?.data,
    ...queryResult,
  };
};

export const useGetApiVersion = () => {
  const { data, ...queryResult } = useGetApiAppInfo<string>("version");

  return {
    apiVersion: data,
    ...queryResult,
  };
};

export const useGetApiServices = () => {
  const { data, ...queryResult } = useGetApiAppInfo<ApiServices>(
    "services",
    true
  );

  return {
    apiServices: data,
    ...queryResult,
  };
};

export const useGetApiAuthConfigs = () => {
  const { data, ...queryResult } =
    useGetApiAppInfo<ApiAuthConfigs>("authConfigs");

  return {
    authConfigs: data,
    ...queryResult,
  };
};
